var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessStoriesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8244 2.69838C6.91862 2.69838 2.36488 5.93113 2.36488 10.9755C2.36488 12.8324 2.82417 14.2022 3.6449 15.2978C4.48149 16.4145 5.76731 17.3444 7.58686 18.1775L8.55212 18.6194L8.21641 19.6264C7.73469 21.0716 6.91725 22.3992 6.09142 23.4909C8.94478 22.5945 12.6719 21.208 15.3071 19.4511C17.92 17.7092 19.3884 16.3382 20.2187 15.0608C21.0188 13.8298 21.2839 12.5966 21.2839 10.9755C21.2839 5.93113 16.7302 2.69838 11.8244 2.69838ZM0 10.9755C0 4.1954 6.08824 0.333496 11.8244 0.333496C17.5606 0.333496 23.6488 4.1954 23.6488 10.9755C23.6488 12.9017 23.3227 14.6246 22.2014 16.3497C21.1102 18.0284 19.3269 19.6134 16.6189 21.4189C13.0992 23.7652 8.00027 25.4287 5.0818 26.2622C4.12276 26.536 3.35878 25.9733 3.02992 25.3872C2.70599 24.8098 2.62605 23.9178 3.24477 23.2272C4.07279 22.303 4.98048 21.1128 5.58841 19.8285C4.0207 18.9973 2.71165 17.9963 1.75225 16.7156C0.576854 15.1468 0 13.2571 0 10.9755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.1035 9.47851C17.5652 9.01674 17.5652 8.26805 17.1035 7.80629C16.6417 7.34452 15.893 7.34452 15.4312 7.80629L10.3629 12.8746L8.25293 10.7646C7.79116 10.3029 7.04248 10.3029 6.58071 10.7646C6.11893 11.2264 6.11893 11.9751 6.58071 12.4369L9.50213 15.3583C9.89044 15.7465 10.4815 15.8084 10.9343 15.5437C11.0585 15.4867 11.1748 15.4072 11.2771 15.3049L17.1035 9.47851Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessStoriesIcon);
export default __webpack_public_path__ + "static/media/success-stories-icon.a620d1fe51f8d7b056f65bac459604a9.svg";
export { ForwardRef as ReactComponent };